import { useMemo } from 'react';
import { LegalPageLayout } from '../components/legal-page-layout';
import { MarkdownRenderer } from '@/components/ui/markdown-renderer';
import { acceptableUseContent } from '../data/acceptable-use-content';
import { extractHeadings } from '../utils/extract-headings';

export function AcceptableUsePage() {
  const headings = useMemo(() => extractHeadings(acceptableUseContent), []);

  return (
    <LegalPageLayout title="Politica de Uso Aceptable" lastUpdated="Marzo 2026" headings={headings}>
      <MarkdownRenderer content={acceptableUseContent} />
    </LegalPageLayout>
  );
}
